import { render, staticRenderFns } from "./recommend.vue?vue&type=template&id=b3dbddda&scoped=true"
import script from "./recommend.vue?vue&type=script&lang=js"
export * from "./recommend.vue?vue&type=script&lang=js"
import style0 from "./recommend.vue?vue&type=style&index=0&id=b3dbddda&prod&lang=scss"
import style1 from "./recommend.vue?vue&type=style&index=1&id=b3dbddda&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3dbddda",
  null
  
)

export default component.exports